import { HStack, Avatar, Button, Menu, MenuButton, MenuList, Text, Box, Stack } from '@chakra-ui/react'

import { AuthService } from './services/AuthService';
import { AppContext } from './comments/AppContext';
import React from 'react';

export const LoginBlock = () => {

  const { isAuthenticated, roles }  = React.useContext(AppContext);

  const account = AuthService.account;

  const onLogout = async () => {
    AuthService.logoutPopup();
  }

  const onLogin = () => {
    AuthService.loginPopup();
  }

  return (
    <HStack spacing={{ base: '2', md: '4' }}>
      {isAuthenticated
        ? <>
          <Menu placement='bottom-end'>
            <MenuButton>
              <Avatar name={account?.name} boxSize="10" />
            </MenuButton>
            <MenuList>
              <Stack pb='4' pe='4' align='end'>
                <HStack px='4' py='2' spacing='2'>
                  <Avatar name={account?.name} boxSize="10" />
                  <Box>
                    <Text fontWeight={600} px='4' mb='2' size='md'>{account?.name}</Text>
                    <Text px='4' size='sm'>{account?.username}</Text>  
                    <Text px='4' fontSize='sm' color='gray.500'>{roles.join(', ')}</Text>
                  </Box>
                </HStack>
                <Button variant='outline' onClick={onLogout}>Logout</Button>
              </Stack>
            </MenuList>
          </Menu>
        </>
        : <Button variant='ghost' onClick={onLogin} >Login</Button>
      }
    </HStack>)
}